import {useNavigate} from "react-router-dom";
import {useCallback, useEffect, useRef, useState} from "react";
import KeywordDropdownSearchForm from "../shared/components/KeywordDropdownSearchForm";
import TableWithActionsDropdown, {Column} from "../shared/components/TableWithActionsDropdown";
import { Dropdown } from "react-bootstrap";
import {estimateService} from "../services/EstimateService";
import LoadingSpinner from "../shared/components/loadingSpinner";
import {getBusinessOrCustomerName, isNullOrEmpty} from "../shared/sharedFunctions";

const PAGE_SIZE = 20
const EstimateListPage: React.FC = () => {
    const navigate = useNavigate();
    const [searchKeywords, setSearchKeywords] = useState([])
    const [dropDownOptions, setDropdownOptions] = useState(["All", "Pending", "No Sq Ft"])
    const [activeDropdown, setActiveDropdown] = useState("All")
    const [totalItemCount, setTotalItems] = useState(0)
    const [isSearching, setIsSearching] = useState(false)
    const [estimateListData, setEstimateListData] = useState([])
    const requestIdRef = useRef(0);
    useEffect(() => {
        onSearch();
    }, []);

    function onSearch(page = 0, size = PAGE_SIZE, sortField = 'statusDescription', orderByDesc = false): any {
        if(!isSearching)
            setIsSearching(true)
        const thisRequestId = ++requestIdRef.current;
        return estimateService
            .searchEstimates(
                searchKeywords,
                activeDropdown === 'All' ? null : activeDropdown === 'Pending' ? 'Pending' : 'NoSqFt',
                page,
                size,
                sortField,
                orderByDesc
            )
            .then((postRes) => {
                if (thisRequestId !== requestIdRef.current) return;
                if (postRes) {
                    setEstimateListData(postRes.items || []);
                    setTotalItems(postRes.totalItemsCount);
                }
                setIsSearching(false)
                return postRes;
            });
    }
    
    
    
    const columns: Column<any>[] = [
        { label: "Name", varName: "name", render: (a) => `${getBusinessOrCustomerName(a)}` },
        { label: "Date", varName: "whenSubmitted", render: (a) => {return new Date(a.whenSubmitted).toLocaleDateString('en-US', {month: '2-digit', day: '2-digit', year: 'numeric',})}},
        { label: "Property", varName: "isCommercialAddress", render: (a) => a.isCommercialAddress ? 'Commercial' : 'Residential' },
        { label: "Status", varName: "statusDescription", render: (a) => {return <span className={"estimateStatus " + (a.statusDescription === 'pending' ? 'pending' : a.statusDescription === 'No Sq. Ft.' ? 'noSqFt' : '')}>{a.statusDescription}</span>}},
        { label: "Employee", varName: "estimatorName", render: (a) => {return a.estimatorName ? a.estimatorName : 'None'} },
    ];
    return (
        <>
            <div className="container-fluid ptCustom">
                <div className="row">
                    <div className="col-12 my-2">
                        <div className="card shadow-sm rounded-lg">
                            <div className="card-body p-4">
                                <KeywordDropdownSearchForm searchKeywords={searchKeywords} DropdownOptions={dropDownOptions} onSearch={onSearch} setSearchKeywords={setSearchKeywords} activeDropdown={activeDropdown} setActiveDropdown={setActiveDropdown}/>
                                <TableWithActionsDropdown
                                    data={estimateListData}
                                    defaultSortField={'whenSubmitted'}
                                    defaultSortDesc={true}
                                    columns={columns} 
                                    pageSize={PAGE_SIZE}
                                    totalCount={totalItemCount}
                                    onPageChange={onSearch}
                                    actions={(data) => (
                                        <>
                                            <Dropdown.Item onClick={() => navigate('/admin/estimate-details', {state: {customerId: data.customerId, jobId: data.jobId, propertyAddress: null}})}>
                                                <i className="fa-light fa-pencil"></i> Edit
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={() => {
                                                estimateService.claimEstimate(data.jobId).then(r => {
                                                    onSearch()
                                                })
                                            }}>
                                                <i className="fa-regular fa-briefcase"></i> Claim Job
                                            </Dropdown.Item>
                                        </>
                                        
                                    )}
                                />
                                {isSearching && <LoadingSpinner/>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default EstimateListPage